import styled from 'styled-components';

const SynthesisDistributionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  color: white;
  min-height: 100vh;
  font-family: ${(props) => props.theme.fonts.sfcompact};
  animation-duration: 1s;
  animation-name: appear;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    margin: 16px;
    height: 120vh;
  }

  .loader {
    position: absolute;
    left: 175px;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
  }

  .header-subtitle {
    color: white;
  }

  .synthesisIndicatorLabel {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    margin-bottom: 20px;
  }

  .synthesisContentTitle {
    display: grid;
    gap: 2rem;

    h2 {
      font-family: ${(props) => props.theme.fonts.oswald};
      font-size: 24px;
      text-transform: uppercase;
    }
  }

  .synthesisContentLine {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  .synthesisContentBody {
    min-height: 300px;
    position: relative;
  }

  .synthesisLeftIndicator {
    margin-bottom: 30px;
    min-height: 110px;
    animation: opacity 1s;
    opacity: 1;
  }

  .synthesisLeftIndicatorValue {
    font-family: ${(props) => props.theme.fonts.silkserif_regular};
    font-size: 58px;
  }

  .synthesisRightIndicatorRank {
    font-family: ${(props) => props.theme.fonts.silkserif_regular};
    font-size: 50px;
    margin-left: 30px;
  }

  .synthesisRightIndicator {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0 50px;
    min-height: 110px;
  }

  .synthesisRightIndicator:not(:last-child) {
    margin-bottom: 25px;
  }

  .synthesisRightIndicatorValue {
    font-family: ${(props) => props.theme.fonts.silkserif_regular};
    font-size: 25px;
    line-height: 1.5;
  }

  .indicateurWrapper {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    min-width: 400px;
  }

  .synthesisContent {
    display: grid;
    grid-template-columns: 0 1fr 1fr 140px;
    grid-template-areas: '. left middle right';
    gap: 2rem;

    @media (max-width: 1200px) {
      grid-template-columns: 1fr 1fr 140px;
      grid-template-areas: 'left middle right';
    }
  }

  .synthesisLeftContent {
    grid-area: left;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    .synthesisContentTitle {
      grid-template-columns: 12rem 1fr;
    }
  }

  .synthesisRightContent {
    grid-area: middle;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    .synthesisContentTitle {
      grid-template-columns: 10rem 1fr;
    }
  }

  .synthesisHeader {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-top: 30px;
  }

  .title {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 24px;
  }

  .subtitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 37px;
    text-transform: uppercase;
    margin-top: 10px;
  }

  .filtersContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-direction: column;
      width: 100%;
      gap: 16px;
    }
  }

  .synthesisContainer {
    display: flex;
    flex-direction: column;
    gap: 5rem;
    z-index: 3;
    padding: 30px 7vw;

    @media (max-width: 1200px) {
      padding: 20px 5vw;
    }

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      padding: 16px;
      width: calc(100vw - 32px);
    }
  }

  .mapboxgl-ctrl-bottom-right {
    display: none !important;
  }

  .mapboxgl-ctrl-logo {
    display: none !important;
  }

  .linkButtonContainer {
    grid-area: right;
    position: relative;
    display: flex;
    justify-content: flex-end;
  }

  .filtersContainer {
    .label {
      font-weight: 600;
      color: #e25c32;
      font-size: 14px;
    }
  }

  .linkButton {
    position: absolute;
    bottom: 5rem;
  }

  .linkButton:hover {
    opacity: 0.8;
  }

  a {
    text-decoration: none;
  }
`;

export default SynthesisDistributionContainer;
